import { ACTIONS } from '../actions/user-topic';

export default (state = {
    typeTopic: '',
    tabMenu: [],
    currentTitleTopic: '',
}, action) => {
    switch (action.type) {
        case ACTIONS.GET_CATEGORY_TOPICS_SUCCESS:
            return {
                ...state,
                tabMenu: action.list,
                typeTopic: action.typeTopic,
            };
        case ACTIONS.SET_TITLE_TOPIC:
            return {
                ...state,
                currentTitleTopic: action.title,
            };
        default:
            return state;
    }
};
